import * as angular from 'angular';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';

const componentOptions = {
    bindings: {
        available: '=',
        quantity: '=',
        seats: '=',
        modules: '=',
        isSeats: '=',
        view: '=',
        dataequalrow: '=',
        index: '=',
        last: '='
    },
    controllerAs: 'ibSeatMapBoxCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-seat-map-box-view.html';
    }]
};
const componentInfo = {
    module: 'ib-seat-map-box-module',
    selector: 'ibSeatMapBox',
    inject: ['$scope', 'localStorageService', 'DatalayerUtilsService', 'CommonsUtilService', 'AncillariesUtilsService'],
    required: ['ib-web-ancillaries-module']
};


export class ibSeatMapBox implements ng.IController {
    public quantity;

    constructor (
        private $scope: angular.IScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private CommonsUtilService: CommonsUtilService,
        private AncillariesUtilsService: AncillariesUtilsService) {

    }


    $onInit (): void {
        this.checkSeats();
    }

    checkSeats = (): void => {
        const seatsQuanty = this.localStorageService.get('seatsQuanty');
        if (!seatsQuanty || seatsQuanty <= 0) {
            let index;
            const shoppingBasket: any = this.localStorageService.get('headerModel');
            const headerModel = shoppingBasket.shoppingBasket ? shoppingBasket.shoppingBasket.seats : shoppingBasket.headerModel.shoppingBasket.seats;
            if (!headerModel.hasSeats) {
                this.quantity = 0;
            } else {
                this.quantity = 0;
                for (index = 0; index < headerModel.segments.length; index++) {
                    this.quantity += headerModel.segments[index].quanty;
                }
            }
        } else {
            this.quantity = seatsQuanty;
        }
    };

    /**
     * Emit event to parent for open modal of seat map
*/
    openSeatMap = (): void => {
        this.DatalayerUtilsService.updateDatalayerActionForAncillaries('elegir asiento', 'clic', 'anadir');
        this.AncillariesUtilsService.isMMBFlow() && this.CommonsUtilService.setTitlePage('MMB_SELECT_SEATS_MODAL_TITLE');
        this.$scope.$emit('openSeatMap');
    };
}
try {
    const mod = angular.module(componentInfo.module);
    ibSeatMapBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSeatMapBox })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibSeatMapBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSeatMapBox })
    );
}
